import { ComponentChild, Component, h } from 'preact'
import LazyLoader from '../lazy-loading/LazyLoader'

interface Props {
  idx: number,
  title: string,
  customClass?: string,
  style?: Object,
  metadata?: ComponentChild,
  navigation?: {
    url: string,
    target?: '_blank'
  },
  imageSrc?: string
}

interface State {}

class Card extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }

  render ({ customClass, style, navigation, title, imageSrc, metadata }: Props, state: State) {
    return (
      <li
        class={`card ${customClass} card-widget-wrapper`}
        style={style}>
        {
          navigation ? (
            <a href={navigation.url} class='card_url' target={navigation?.target}>
              {imageSrc
                ? <LazyLoader type='background' src={imageSrc} classNames='card_image' />
                : null }
              <div className='card_info'>
                <h3 className='card_info__title card-widget-title'>{ title }</h3>
                {
                  metadata ? (
                    <p className='text--meta card-info__metadata'>
                      { metadata }
                    </p>
                  ) : null
                }
              </div>
            </a>
          ) : null
        }
      </li>
    )
  }
}

export default Card
